import { css } from "styled-components"

export const HeaderCss = css`
  position: fixed;
  grid-area: Header;
  flex-shrink: 0;
  z-index: 5500;
  width: 100%;
  height: 45px;
  background: linear-gradient(270.54deg, #20c2f1 49.88%, #0070f4 135.73%);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 57px 0 10px;
  box-shadow: 0px 3px 6px var(--shadow);
  a {
    display: flex;
    text-decoration: none;
  }
  svg {
    position: relative;
    height: 30px;
    width: 30px;
  }
  span {
    font-family: PoppinsVF;
    font-size: 16px;
    font-weight: 700;
    color: var(--white);
    margin-left: 10px;
    align-self: center;
  }
`
